export const triggerScrollDepthEvent = (percentScrolled) => {
    if (typeof window === 'undefined' || !window.dataLayer) return
    window.dataLayer.push({
        event: 'scroll_depth',
        percent_scrolled: percentScrolled
    })
}
